// 引入子路由
import Frame from '../frame/subroute.vue'
// 配置路由
export default [
 /* {
    path: "*",
    redirect: '/userAgreement'
  },*/
  {
    path: "*",
    redirect: '/hnmj/index'
  },
  {
    path: "/coinState",
    name: '/coinState',
    component: resolve => require(['../page/coinState.vue'], resolve)
  },
  {
    path: "/privacy",
    name: '/privacy',
    component: resolve => require(['../page/privacy.vue'], resolve)
  },
  {
    path: "/question",
    name: '/question',
    component: resolve => require(['../page/question.vue'], resolve)
  },
  {
    path: "/playState",
    name: '/playState',
    component: resolve => require(['../page/playState.vue'], resolve)
  },
  {
    path: "/userAgreement",
    name: '/userAgreement',
    component: resolve => require(['../page/userAgreement.vue'], resolve)
  },
  {
    path: "/master",
    name: '/master',
    component: resolve => require(['../page/master.vue'], resolve)
  },

  { 
    path: '/douniu',
    component: Frame,
    children: [
      {
        path: 'index', 
        name: 'inedx', 
        component: resolve => require(['../page/douniu/index.vue'], resolve)
      },
    ],
  },
  { 
    path: '/hnmj',
    component: Frame,
    children: [
      {
        path: 'index', 
        name: 'inedx', 
        component: resolve => require(['../page/hnmj/index.vue'], resolve)
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/config/routes.js